import Swal from "sweetalert2";

export const Alert = {
  success: (title, text) => {
    Swal.fire({
      icon: "success",
      title: title,
      text: text,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
    });
  },

  error: (title, text) => {
    Swal.fire({
      icon: "error",
      title: title,
      text: text,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
    });
  },

  warning: (title, text) => {
    Swal.fire({
      icon: "warning",
      title: title,
      text: text,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
    });
  },
};
